import styled from 'styled-components';

export const NeutralNavigationUI = styled.div`
  width: 100%;
  background-color: #1064a3;

  display: flex;
  justify-content: space-between;
  padding: 15px 10%;

  img {
    height: 60px;
  }

  .item {
    display: flex;
    justify-content: center;

    align-items: center;
    gap: 10px;
  }

  .layout {
    color: #d6dde6;
  }

  .small {
    font-size: 13px;
    font-weight: 300;
    width: 250px;
    line-height: 15px;
  }

  .big {
    font-size: 27px;
    width: 320px;

    line-height: 30px;
    font-weight: 900;
    font-family: 'Roboto', sans-serif;
  }
`;
